import { color, display, styled } from '@mui/system';
import images from 'src/config/images';
import ListItemButton from '@mui/material/ListItemButton';
import theme, { mobileTypography, palette, typography } from 'src/config/theme';
import { Avatar, Box, alpha } from '@mui/material';
export const LogoContainer = styled(Box)({
  width: '280px',
  height: '84px',
  borderWidth: '0px 1px 1px 0px',
  borderStyle: 'solid',
  borderColor: `${alpha(palette.gery.black, 0.1)}`,
  backgroundColor: palette.gery.white,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  [theme.breakpoints.down('md')]: {
    height: '72px',
    justifyContent: 'flex-start',
    padding: '16px'

  },
})
export const Logo = styled('img')({
  // width: '189px',
  height: '65px',
  [theme.breakpoints.down('md')]: {
    height: '40px',
  },
});
Logo.defaultProps = {
  src: images.logoW,
};
export const Logo2 = styled('img')({
  width: '70px',
  height: '22px',
  margin: '0 auto',
  // paddingTop: 15,
  // paddingBottom: 15,
});
Logo2.defaultProps = {
  src: images.logo,
};
export const ListItem = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== 'isPermanentOpen',
})(({ isPermanentOpen }) => ({
  '& .MuiListItemText-root': {
    color: theme.palette.gery.black,
    opacity: isPermanentOpen ? 0.6 : 0,
    transition: 'opacity 0.1s ease-in-out',
    '& .MuiTypography-root': {
      ...typography.h5,
      [theme.breakpoints.down('md')]: {
        ...mobileTypography.h5
      },

    },
  },
  '& .MuiListItemIcon-root': {
    minWidth: '44px',
    opacity: 1,
    display: 'flex',
    justifyContent: 'center',
  },
  padding: isPermanentOpen ? '12px 24px' : '12px',
  [theme.breakpoints.down('md')]: {
    padding: isPermanentOpen ? '12px 16px' : '12px',
  },
  justifyContent: isPermanentOpen ? 'flex-start' : 'center',
  '&.active': {
    backgroundColor: theme.palette.primary.light1,
    '& .MuiListItemText-root': {
      opacity: 1,
      color: theme.palette.primary.main
    },
    '& .MuiListItemIcon-root': {
      opacity: 1,
      color: theme.palette.primary.main,

      '& svg': {
        color: theme.palette.primary.main,
        fill: theme.palette.primary.main,
      },

    },

    '&::before': {
      display: 'none',
    },
    '&::after': {
      display: 'none',
    },
  },
}));


export const SidebarCloseContainer = styled(Avatar)({
  width: '40px',
  height: '40px',
  position: 'absolute',
  bottom: '50px',
  left: '20px',
  padding: '10px',
  backgroundColor: palette.primary.light3,
  border: `1px solid ${palette.primary.light1}`,
  color: palette.primary.main,
  cursor: 'pointer'


})
